import Feature from 'owa-feature-flags/lib/store/schema/Feature';

/**
 * Please keep in alphabetical order for ease of reading
 */
export default {
    'ads-GDPRLGPD-managebuttonprimarytext-mini': <Feature>{},
    'adsexp-mini-NoTLClientCall-202211-treatment': <Feature>{},
    'adsexp-mini-NoTLClientCall-202211-control': <Feature>{},
    'ads-Prompt-TestSkipCheck': <Feature>{},
    'ads-native-MSAN-Countries-AAML-202210': <Feature>{},
    'ads-native-MSAN-CC-AFR-202210': <Feature>{},
    'ads-native-MSAN-CC-LATAM-202210': <Feature>{},
    'ads-native-MSAN-CC-MENA-Green-202210': <Feature>{},
    'ads-native-MSAN-CC-MENA-Red-202210': <Feature>{},
    'ads-native-MSAN-SendContentUrl': <Feature>{},
    'ads-native-MSAN-SendDevice': <Feature>{},
    'ads-native-MSAN-SendExpHeader-SendT': <Feature>{},
    'ads-native-MSAN-SendExpHeader-SendC': <Feature>{},
    'ads-native-MSAN-SendRid': <Feature>{},
    'adsexp-DisplayOffNativeOn-treament': <Feature>{},
    'adsexp-DisplayOffNativeOn-control': <Feature>{},
    'adsExp-DONO-AdInPrimary-e1': <Feature>{},
    'adsExp-DONO-TwoAdsOther-e1': <Feature>{},
    'adsexp-mini-BingMarkets-202109-tr': <Feature>{},
    'adsexp-mini-BingMarkets-202109-cr': <Feature>{},
    'ads-nativeAdsBingMobileShowPersonaExp': <Feature>{},
    'ads-nativeAdsPrebidMobileAllInbox': <Feature>{},
    'auth-progressiveWebApp': <Feature>{},
    'cmp-encryption': <Feature>{},
    'doc-consumerUrl': <Feature>{},
    'miniAE-NativeUX-treatment': <Feature>{},
    'mini-nativeads-cjeu-killswitch': <Feature>{},
    'miniAE-NativeUX-control': <Feature>{},
    'miniAE-NativeUX-update': <Feature>{},
    'miniAE-NoTripleliftClientCall-treatment': <Feature>{},
    'miniAE-NoTripleliftClientCall-control': <Feature>{},
    'miniAE-Refresh-202206-20s': <Feature>{},
    'miniAE-Refresh-202206-30s': <Feature>{},
    'miniAE-Refresh-202206-40s': <Feature>{},
    'miniAE-Refresh-202206-control': <Feature>{},
    'mini-cal': <Feature>{},
    'mini-campaignTracker': <Feature>{},
    'mini-errorpopup': <Feature>{},
    'mini-euad-0': <Feature>{},
    'mini-euad-1': <Feature>{},
    'mini-euad-2': <Feature>{},
    'mini-euad-3': <Feature>{},
    'mini-euad-4': <Feature>{},
    'mini-euad-TestSkipOptinCheck': <Feature>{},
    'mini-feedbackDF': <Feature>{},
    'mini-gdprAds-TestSkipTcfCheck': <Feature>{},
    'mini-gdprAds-TestSkipFirstCookieCheck': <Feature>{},
    'mini-extend-screen-loader': <Feature>{},
    'mini-lgpdAds': <Feature>{},
    'mini-lgpdAds-China': <Feature>{},
    'mini-lgpdAds-Turkey': <Feature>{},
    'mini-MSAN-APAC-202203': <Feature>{},
    'mini-MSAN-EMEA-202204': <Feature>{},
    'mini-lgpdAds-TestSkipCheck': <Feature>{},
    'mini-markAsJunkMultiSelect': <Feature>{},
    'mini-at-mentions': <Feature>{},
    'mini-roosterjs-compose': <Feature>{},
    'mini-serviceworker': <Feature>{},
    'mini-suggestionsQF': <Feature>{},
    'mini-surveyV1': <Feature>{},
    'mini-sw-enabled': <Feature>{},
    'mini-sw-enabled-chrome': <Feature>{},
    'mini-sw-enabled-safari': <Feature>{},
    'mini-zeroQuerySuggestions': <Feature>{},
    'rp-requestPersonaResponseShape': <Feature>{},
    'tri-favorites-roaming': <Feature>{}, // Same as owa-mail
    'mini-tapFeedback': <Feature>{},
    'mini-safe-area': <Feature>{},
    'mini-cal-agenda-avatars': <Feature>{},
    'mini-feedback-link': <Feature>{},
    'mini-liveSite-deleteMail': <Feature>{},
    'mini-wsb': <Feature>{},
    'mini-unified-search': <Feature>{},
    'mini-cal-defaultOnlineMeetingSetting': <Feature>{},
    'mini-prefetch-events-cal': <Feature>{},
    'mini-cal-speedyMeetingsSetting': <Feature>{},
    'mini-mail-a2hs-customPrompt': <Feature>{},
    'mini-mail-a2hs-persistent': <Feature>{},
    'mini-mail-quick-compose': <Feature>{},
    'mini-ocv-feedback': <Feature>{},
    'mini-cal-picker-switch': <Feature>{},
    'mini-upnext': <Feature>{},
    'mini-cal-bootstrap-diagnostics': <Feature>{},
    // diagnostics
    'mini-diagnostics': <Feature>{},
    'mini-diagnostics-verbose-tracking': <Feature>{},
    'mini-nobtree': <Feature>{},
    'mini-edge-upsell-experiment': <Feature>{},
    'mini-mailto': <Feature>{},
    'mini-peopleCard-delete': <Feature>{},
    'mini-push-notification-mail': <Feature>{},
    'mini-push-notification-reminder': <Feature>{},
    'mini-push-notification-onboarding': <Feature>{},
    'mini-itemEmail-previewer': <Feature>{},
    'adsexp-mini-prebidTimeout-1s': <Feature>{},
    'adsexp-mini-prebidTimeout-3s': <Feature>{},
    'mini-ad-useast037': <Feature>{},
    'adsExp-mini-AdIcon-202204': {},
    'adsExp-mini-AdIconDropdownMenu-202204': {},
    'adsExp-mini-AdIconFrontDropdownMenu-202204': {},
    'adsExp-mini-AdIconMenu-202204-cr': {},
    // sds-integration
    'mini-sds-integration': <Feature>{},
    // surface-campaign-framework
    'mini-iris-campaign-framework': <Feature>{},
    'mini-diagnose-pincode-issue': <Feature>{},
    // fast module switch
    'mini-fast-module-switch': <Feature>{},
    //shoreline specific flags
    'shoreline-gpsc-flight': <Feature>{},
    //Feature flag for LGPD consent in Canada
    'mini-ads-lgpd-canada': <Feature>{},
};
